import { ParseKeys } from 'i18next';

export enum TossPaymentMethod {
  Card = '카드',
  Transfer = '계좌이체',
  MobilePhone = '휴대폰',
  CultureGiftCertificate = '문화상품권',
  BookGiftCertificate = '도서문화상품권',
}

export type PaymentMethodItem = {
  key: string;
  method: TossPaymentMethod;
  labelKey: ParseKeys<['manage']>;
};

export const TossPaymentMethods: PaymentMethodItem[] = [
  {
    key: 'Card',
    method: TossPaymentMethod.Card,
    labelKey: 'manage:donate_payment_creditcard',
  },
  {
    key: 'Transfer',
    method: TossPaymentMethod.Transfer,
    labelKey: 'manage:donate_payment_banktransfer',
  },
  {
    key: 'MobilePhone',
    method: TossPaymentMethod.MobilePhone,
    labelKey: 'manage:donate_payment_mobile',
  },
  {
    key: 'CultureGiftCertificate',
    method: TossPaymentMethod.CultureGiftCertificate,
    labelKey: 'manage:donate_payment_culture_giftcard',
  },
  {
    key: 'BookGiftCertificate',
    method: TossPaymentMethod.BookGiftCertificate,
    labelKey: 'manage:donate_payment_book_giftcard',
  },
];

export const AccountQueryKeys = {
  SNS_LOGIN: 'sns-login',
  EMAIL_LOGIN_CODE_REQUEST: 'email-login-code-request',
  EMAIL_LOGIN_CODE_CONFIRM: 'email-login-code-confirm',
  PROFILE_UPDATE: 'profile-update',
  VALIDATE_WITHDRAW: 'validate-withdraw',
  WITHDRAW_MUTATE: 'withdraw-mutate',
};
